// extracted by mini-css-extract-plugin
export default {"page":"b1-z","cartModal":"c1-z","checkout":"d1-z","placeholder":"e1-z","account":"f1-z"};